import Education from "./Education";
import Experience from "./Experience";
import Header from "./Header";
import About from "./About";
import "./Resume.css";
import Skills from "./Skills";

const Resume = () => {
  return (
    <div className="page">
      <Header />
      <About />
      <Skills />
      <Experience />
      <Education />
    </div>
  );
};

export default Resume;
